export const AppPermissions = {
  owner: 'own',
  project: {
    add: ['add_project'],
    view: ['view_project', 'view'],
    edit: ['edit_project', 'edit'],
    archive: ['archive_project', 'archive'],
    budget: {
      view: ['view_budget'],
      edit: ['edit_budget'],
    },
    invoice: {
      view: ['view_invoice'],
    },
    bank_account: {
      view: ['view_bank_account'],
      edit: ['edit_bank_account'],
      add: ['add_bank_account'],
      delete: ['delete_bank_account'],
    },
    contract: {
      add: ['add_contract'],
      view: ['view_contract'],
      edit: ['edit_contract'],
    },
    event: {
      view: ['view_project_event'],
      add: ['add_project_event'],
      edit: ['edit_project_event'],
      cancel: ['cancel_project_event'],
    },
    time_deposit: {
      view: ['view_deposit'],
      add_edit: ['add_edit_deposit'],
    },
    borrowing: {
      view_listing: ['view_borrowing_listing'],
      view_record: ['view_borrowing_record'],
      add_record: ['add_borrowing_record'],
      edit_record: ['edit_borrowing_record'],
      view_summary: ['view_borrowing_summary'],
    },
    rollover: {
      view: ['view_rollover'],
      add: ['add_rollover'],
      edit: ['edit_rollover'],
    },
    related_bank_account: {
      view: ['view_parent_bank_account'],
    },
  },
  workflow: {
    view: 'view',
    trigger: 'trigger',
    view_all: 'view_all',
    archive: 'archive',
    hold: ['hold'],
    schedule: {
      view: ['view_workflow_schedule'],
      add: ['add_workflow_schedule'],
      edit: ['edit_workflow_schedule'],
      cancel: ['cancel_workflow_schedule'],
    },
  },
  vendor: {
    add: ['add'],
    view: ['view'],
    edit: ['edit'],
    archive: ['archive'],
    invite: ['invite'],
  },
  invoice: {
    view: ['view'],
    import: ['import'],
  },
};

export const VIEW_MODE = 'view';
